import jsSHA from 'jssha'

export const getSha256Hash = (s: string): string => {
  const shaObj = new jsSHA('SHA-256', 'TEXT', { encoding: 'UTF8' })
  shaObj.update(s)
  const hash = shaObj.getHash('HEX')
  return hash
}
